// export const API_HOST = "http://localhost:9180";
// export const API_HOST = "https://stage.pocketkey.ru/api";
export const API_HOST = "https://qr.pocketkey.ru/api";
export const CLIENT_COUNT_LIST = 15;
export const NOTIFICATION_TIMEOUT = 10000;